import React, { useEffect, useState, useRef } from "react";
import useAuth from "./../../hooks/useAuth";
import {useLocation} from 'react-router-dom';
import { toast } from 'react-toastify';

import { OPENAPI_IMAGE } from "./../../utils/apiCalls";
import {Translate} from 'react-auto-translate';
import ResponseDiv from './Response';
import ImageResponse from "./imageResponse";
import { useSelector } from "react-redux";

function Inner({data = []}) {
    const { state } = useLocation();
    const [titleab, setTitleab] = useState(state?.v?.title);
  const { NotificationsToasts = null } = useSelector((state) => state.user);
    
    const [descab, setDesceab] = useState(state?.v.description);
    const [blogimage, setBlogImage] = useState(state?.v.image);

    const [option, setOption] = useState(false);
    const {getLoggedObject} = useAuth();
    const [loading, setLoading] = useState(false);

    const [description, setDescription] = useState('');

    const [variant, setVariant] = useState(1);
    const [imgsize, setImgSize] = useState('1024x1024');

    const [classify, setClassify] = useState('');
    const [style, setStyle] = useState('');
    const [artist, setArtist] = useState('');
    const [mood, setMood] = useState('');

    const [creativity, setCreativity] =  useState('0.75');
    const [responseAI, setResponseAI] = useState([]);
    const [type, setType] = useState('flexy_templates');


    useEffect(() => {
        const [width, height] = imgsize.split('x');
        setImgHeight(height);
        setImgWidth(width);
    }, [imgsize]);

    const [imgHeight, setImgHeight] = useState('');
    const [imgWidth, setImgWidth] = useState('');

    const do_loop_variants_old = async () => {
        let lang = 'en';
        setLoading(true)
        const user_token = getLoggedObject()?.token;
        const max_tokens = 10;
        const temperature = creativity;
        
        if(classify!=""){
            var classify_u = " and image should be "+classify;
        } else {
            var classify_u = '';
        }

        if(style!=""){
            var style_u = " and image style should be "+style;
        } else {
            var style_u = '';
        }

        if(artist!=""){
            var artist_u = " and artist should be "+artist;
        } else {
            var artist_u = '';
        }

        if(mood!=""){
            var mood_u = " and image should be "+mood;
        } else {
            var mood_u = '';
        }
        const RuussianContent = 'Создайте реалистичное изображение, отражающее идею пользователя ('+description+') ' + classify_u + style_u + artist_u + mood_u;
        const content_submit = 'Design a realistic image where user idea is ('+description+') ' + classify_u + style_u + artist_u + mood_u;
        const payload = lang == "en" ? content_submit : RuussianContent;
        
        const response_ai = await OPENAPI_IMAGE(payload, max_tokens, temperature, user_token, variant, imgsize, imgHeight , NotificationsToasts);
        setLoading(false)
        if(response_ai ==  'error'){
            toast.error(NotificationsToasts?.error_while_connecting?.notification);
            return;
        } 
        if(response_ai ==  'ntoken'){
            toast.error(NotificationsToasts?.account_limit_reached?.notification);
            return;
        } 


        const data = await response_ai.json();
        const final_response = `data:image/png;base64,${data.artifacts[0].base64}`;
        var lines = [final_response];
        setResponseAI(prevResponse => [...prevResponse, ...lines]);
    }

    const do_loop_variants = async () => {
            setLoading(true)
            const user_token = getLoggedObject()?.token;
            const max_tokens = 10;
            const temperature = creativity;
            
            if(classify!=""){
                var classify_u = " and image should be "+classify;
            } else {
                var classify_u = '';
            }
    
            if(style!=""){
                var style_u = " and image style should be "+style;
            } else {
                var style_u = '';
            }
    
            if(artist!=""){
                var artist_u = " and artist should be "+artist;
            } else {
                var artist_u = '';
            }
    
            if(mood!=""){
                var mood_u = " and image should be "+mood;
            } else {
                var mood_u = '';
            }
            const content_submit = 'Design a realistic image where user idea is ('+description+') ' + classify_u + style_u + artist_u + mood_u;
            const payload = content_submit;
            
            const response_ai = await OPENAPI_IMAGE(payload, max_tokens, temperature, user_token, variant, imgsize);
            setLoading(false)
            if(response_ai ==  'error'){
                toast.error("Some error occured while connect with API! Please try again later");
                return;
            } 
            if(response_ai ==  'ntoken'){
                toast.error("You've reached your account limit, Please upgrade your pacakage!");
                return;
            } 
            const final_response = response_ai.data[0].url;
            var lines = [final_response];
            setResponseAI(prevResponse => [...prevResponse, ...lines]);
        }

    const do_make_action = async () => {
        if(description == ''){
            toast.error(NotificationsToasts?.image_description?.notification);
            return;
        }
        var user_variants = variant;
        for (let i = 0; i < user_variants; i++) {
            do_loop_variants();
        }
    }
  
  return (
    <>
   <div className="container-wrappe">
        <div className="main-layout">
            <section className="tool-panel">
            <div className="row">
                <div className="col-md-4">
                <div className="card">
                    <div className="card-body">
                    <section className="tool-header">
                        <div>
                        <div className="svgIcon imgCreator">
                            <img src={blogimage} />
                        </div>
                        <div>
                            <h2>{data?.tool_title}</h2>
                            <p>{data?.tool_description}</p>
                          </div>
                        </div>
                      
                    </section>
                        <div className="mb-3">
                        <label className="form-label" htmlFor="imageDescription">
                        <Translate>Write an image description</Translate>
                        </label>{" "}
                        {/* <span className="float-right text-muted in-text">
                            0/500 characters
                        </span> */}
                        <textarea
                            maxLength={500}
                            placeholder={
                                data?.data?.length > 0 &&
                                data?.data[1]?.placeholder
                              }
                            name="imageDescription"
                            required=""
                            id="imageDescription"
                            className="form-control"
                            style={{ height: 120 }}
                            value={description}
                            onChange={(e)=>setDescription(e.target.value)}
                        />
                        </div>
                        <div className="mt-3 mb-3 row">
                        <div className="col-6 mb-3 col">
                            <label className="form-label"><Translate>Image Size</Translate></label>
                            <select
                            aria-label="Default select example"
                            name="imageSize"
                            className="form-control form-select"
                            value={imgsize}
                            onChange={(e)=>setImgSize(e.target.value)}
                            >
                         
                            <option value="1024x1024">1024px - 1024px</option>
                            <option value="1152x896">1792px - 1024px</option>
                            <option value="896x1152">896px - 1152px</option>
                            <option value="1216x832">1216px - 832px</option>
                            <option value="1344x768">1344px - 768px</option>
                            <option value="768x1344">768px - 1344px</option>
                            <option value="1536x640">1536px - 640px</option>
                            <option value="640x1536">640px - 1536px</option>
                            </select>
                        </div>
                        <div className="col-6 mb-3 col">
                            <label className="form-label"><Translate>Variants</Translate></label>
                            <select
                            aria-label="Number of Variants"
                            name="imageVariant"
                            className="form-control form-select"
                            value={variant}
                            onChange={(e)=>setVariant(e.target.value)}
                            >
                            <option value={1}><Translate>1 variant</Translate></option>
                            <option value={2}><Translate>2 variants</Translate></option>
                            <option value={3}><Translate>3 variants</Translate></option>
                            <option value={4}><Translate>4 variants</Translate></option>
                            </select>
                        </div>
                        </div>
                        <div className="advanceOptions">
                        <div className="accordion">
                            <div className="accordion-item">
                            <h2 className="accordion-header">
                                <button
                                type="button"
                                aria-expanded="false"
                                className="accordion-button collapsed"
                                onClick={()=>setOption(!option)}
                                >
                                <Translate>Advanced Options</Translate>
                                </button>
                            </h2>
                            {
                                option &&
                           
                            <div className="accordion-collapse collaps">
                                <div className="accordion-body">
                                <div className="mt-3 mb-3 row">
                                    <div className="col-6 mb-3 col">
                                    <label className="form-label"><Translate>Classify</Translate></label>
                                    <select
                                        name="imageType"
                                        className="form-control form-select"
                                        id="imageType"
                                        value={classify}
                                        onChange={(e)=>setClassify(e.target.value)}
                                    >
                                        <option value="none"><Translate>None</Translate></option>
                                        <option value="Realistic"><Translate>Realistic</Translate></option>
                                        <option value="Fictional"><Translate>Fictional</Translate></option>
                                    </select>
                                    </div>
                                    <div className="col-6 mb-3 col">
                                    <label className="form-label"><Translate>Style</Translate></label>
                                    <select
                                        name="imageStyle"
                                        className="form-control form-select"
                                        id="imageStyle"
                                        value={style}
                                        onChange={(e)=>setStyle(e.target.value)}
                                    >
                                        <option value="none"><Translate>None</Translate></option>
                                        <option value="3d render"><Translate>3d Render</Translate></option>
                                        <option value="abstract"><Translate>Abstract</Translate></option>
                                        <option value="anime"><Translate>Anime</Translate></option>
                                        <option value="art deco"><Translate>Art Deco</Translate></option>
                                        <option value="cartoon"><Translate>Cartoon</Translate></option>
                                        <option value="digital art"><Translate>Digital Art</Translate></option>
                                        <option value="illustration"><Translate>
                                        Illustration
                                        </Translate></option>
                                        <option value="line art"><Translate>Line Art</Translate></option>
                                        <option value="one line drawing"><Translate>
                                        One Line Drawing
                                        </Translate></option>
                                        <option value="origami"><Translate>Origami</Translate></option>
                                        <option value="pixel art"><Translate>Pixel Art</Translate></option>
                                        <option value="photography"><Translate>Photography</Translate></option>
                                        <option value="pop art"><Translate>Pop Art</Translate></option>
                                        <option value="retro"><Translate>Retro</Translate></option>
                                        <option value="unreal engine"><Translate>
                                        Unreal Engine
                                        </Translate></option>
                                        <option value="vaporwave"><Translate>Vaporwave</Translate></option>
                                    </select>
                                    </div>
                                    <div className="col-6 mb-3 col">
                                    <label className="form-label"><Translate>Artist</Translate></label>
                                    <select
                                        name="imageArtist"
                                        className="form-control form-select"
                                        id="imageArtist"
                                        value={artist}
                                        onChange={(e)=>setArtist(e.target.value)}
                                    >
                                        <option value="none"><Translate>None</Translate></option>
                                        <option value="andy warhol"><Translate>Andy Warhol</Translate></option>
                                        <option value="ansel adams"><Translate>Ansel Adams</Translate></option>
                                        <option value="claude monet"><Translate>
                                        Claude Monet
                                        </Translate></option>
                                        <option value="dr. seuss"><Translate>Dr. Seuss</Translate></option>
                                        <option value="pablo picasso"><Translate>
                                        Pablo Picasso
                                        </Translate></option>
                                        <option value="pixar"><Translate>Pixar</Translate></option>
                                        <option value="salvador dali"><Translate>
                                        Salvador Dali
                                        </Translate></option>
                                        <option value="south park"><Translate>South Park</Translate></option>
                                        <option value="van gogh"><Translate>Van Gogh</Translate></option>
                                    </select>
                                    </div>
                                    <div className="col-6 mb-3 col">
                                    <label className="form-label">Mood</label>
                                    <select
                                        name="imageMood"
                                        className="form-control form-select"
                                        id="imageMood"
                                        value={mood}
                                        onChange={(e)=>setMood(e.target.value)}
                                    >
                                        <option value="none"><Translate>None</Translate></option>
                                        <option value="aggressive"><Translate>Aggressive</Translate></option>
                                        <option value="angry"><Translate>Angry</Translate></option>
                                        <option value="boring"><Translate>Boring</Translate></option>
                                        <option value="bright"><Translate>Bright</Translate></option>
                                        <option value="calm"><Translate>Calm</Translate></option>
                                        <option value="cheerful"><Translate>Cheerful</Translate></option>
                                        <option value="chilling"><Translate>Chilling</Translate></option>
                                        <option value="colorful"><Translate>Colorful</Translate></option>
                                        <option value="dark"><Translate>Dark</Translate></option>
                                        <option value="neutral"><Translate>Neutral</Translate></option>
                                    </select>
                                    </div>
                                </div>
                                </div>
                            </div>
                             }
                            </div>
                        </div>
                        </div>
                       
                        <button disabled={loading} className="mt-3 w-100 btn btn-primary" onClick={()=>do_make_action()}>
                                {loading?
                                    <div className="flex">
                                        <span><Translate>Loading...</Translate></span>
                                    </div>
                                :
                                    <Translate>Generate Image</Translate>
                                }
                            </button>
                    {/* <button type="button" className="exampleData m-auto btn btn-link">
                        Add example data
                    </button> */}
                    </div>
                </div>

                 <small className="imageNote">
                    <svg
                    version="1.1"
                    id="Layer_1"
                    xmlns="http://www.w3.org/2000/svg"
                    width="15px"
                    height="15px"
                    x="0px"
                    y="0px"
                    viewBox="0 0 330 330"
                    enableBackground="new 0 0 330 330;"
                    >
                    <g>
                        <g>
                        <g>
                            <path
                            d="M165,0.008C74.019,0.008,0,74.024,0,164.999c0,90.977,74.019,164.992,165,164.992s165-74.015,165-164.992
        C330,74.024,255.981,0.008,165,0.008z M165,299.992c-74.439,0-135-60.557-135-134.992S90.561,30.008,165,30.008
        s135,60.557,135,134.991C300,239.436,239.439,299.992,165,299.992z"
                            />
                            <path
                            d="M165,130.008c-8.284,0-15,6.716-15,15v99.983c0,8.284,6.716,15,15,15s15-6.716,15-15v-99.983
        C180,136.725,173.284,130.008,165,130.008z"
                            />
                            <path
                            d="M165,70.011c-3.95,0-7.811,1.6-10.61,4.39c-2.79,2.79-4.39,6.66-4.39,10.61s1.6,7.81,4.39,10.61
        c2.79,2.79,6.66,4.39,10.61,4.39s7.81-1.6,10.609-4.39c2.79-2.8,4.391-6.66,4.391-10.61s-1.601-7.82-4.391-10.61
        C172.81,71.61,168.95,70.011,165,70.011z"
                            />
                        </g>
                        </g>
                    </g>{" "}
                    <g />
                    <g />
                    <g />
                    <g />
                    <g />
                    <g />
                    <g />
                    <g />
                    <g />
                    <g />
                    <g />
                    <g />
                    <g />
                    <g />
                    <g />
                    </svg>{" "}
                    <Translate>
                    Note: This tool will deduct 150 words per image and generated images
                    are not stored in your account.
                    </Translate>
                </small> 
                </div>
                <div className="ai-board col-md-8 col">
                    <ImageResponse loading={loading} responseAI={responseAI} contentCategory={type} image_data={1} />
                </div>
            </div>
            </section>
        </div>
        <div
            style={{
            position: "fixed",
            zIndex: 9999,
            inset: 16,
            pointerEvents: "none"
            }}
        />
        </div>



    </>
);
}

export default Inner;
